import axios from "../utils/axios";

export function createRequestEvent(data, token) {
  return new Promise(function (resolve, reject) {
    axios
      .post("/request-events", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          return resolve(res.data);
        } else {
          reject(res.data.message);
        }
      })
      .catch((err) => reject(err));
  });
}

export function updateRequestEvent(requestedEventId, token) {
  return new Promise(function (resolve, reject) {
    axios
      .patch(
        `/request-events/${requestedEventId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        if (res.status === 200) {
          return resolve(res.data);
        } else {
          reject(res.data.message);
        }
      })
      .catch((err) => reject(err));
  });
}
export function createRequestEventFromChat(data, token) {
  return new Promise(function (resolve, reject) {
    axios
      .post("/request-events/chat", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          return resolve(res.data);
        } else {
          reject(res.data.message);
        }
      })
      .catch((err) => reject(err));
  });
}

export function getAllRequestEvents(room) {
  return new Promise(function (resolve, reject) {
    axios
      .get(`/request-events/${room}`)
      .then((res) => {
        if (res.status === 200) {
          return resolve(res.data);
        } else {
          reject(res.data.message);
        }
      })
      .catch((err) => reject(err));
  });
}

export function createEventFromRequestEvent(data, token) {
  return new Promise(function (resolve, reject) {
    axios
      .post("/request-events/event", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          return resolve(res.data);
        } else {
          reject(res.data.message);
        }
      })
      .catch((err) => reject(err));
  });
}

export function getHomepageRequestEvents(token) {
  return new Promise(function (resolve, reject) {
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    axios
      .get(`/request-events/home`, {
        headers,
      })
      .then((res) => {
        if (res.status === 200) {
          return resolve(res.data);
        } else {
          reject(res.data.message);
        }
      })
      .catch((err) => reject(err));
  });
}

export function cancelRequestEvent(requestedEventId, token) {
  return new Promise(function (resolve, reject) {
    axios
      .patch(
        `/request-events/${requestedEventId}/cancel`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        if (res.status === 200) {
          return resolve(res.data);
        } else {
          reject(res.data.message);
        }
      })
      .catch((err) => reject(err));
  });
}
